import React, { useEffect } from "react";
import styles from "./privacy.module.css";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);
  return (
    <>
      {/* <section className={`${styles.bioSection} h-80`}> */}

      <section className="shadow border-t-2 border-slate-200">
        {/* <div className={styles.imageContainer}> */}
        <div className="flex justify-center items-center text-center py-32 lg:px-4 px-8">
          {" "}
          <p className=" text-[#f6655f] text-4xl leading-normal font-bold">
            PRIVACY POLICY AND USER AGREEMENT{" "}
          </p>
        </div>
      </section>

      <section className="my-24 px-8 md:px-10 py-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>Privacy</h2>
          <p className={`${styles.paragraph}`}>
            This Privacy Policy describes how we collect and use the personal
            information you provide on the websites of Ribi, Inc. (“Web Pages”).
            It also describes the choices available to you regarding our use of
            your personal information and how you can access and update this
            information. Ribi, Inc. (“we” or “us”) complies with the Nigeria
            Data Protection Act.
          </p>
        </div>
        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>
            Collection of Personal Information
          </h2>
          <p className={`${styles.paragraph}`}>
            We collect the following types of personal information from you
            (“Personal Information”): Contact information, such as first and
            last name, email address, and phone number. Demographic information,
            such as age, gender. Bio-data, such as blood type and genotype.
            Location information, such as home address, city, state.
          </p>
        </div>
        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>User Consent</h2>
          <p className={`${styles.paragraph}`}>
            You are 18+ and allows us to share your Personal Information with
            third parties such as Hospitals, Blood banks, medical research
            institutions, pharmaceutical companies, biotech companies and health
            ministries for purposes of blood transfusion, security, medical
            research, Statistics, diseases eradication and drugs discovery.
          </p>
        </div>
        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>Security</h2>
          <p className={`${styles.paragraph}`}>
            The security of your Personal Information is important to us. When
            you enter information into our forms, we encrypt the transmission of
            that information using secure socket layer technology (SSL). We
            follow generally accepted industry standards to protect your
            Personal Information submitted to us, both during transmission and
            once we receive it. No method of transmission over the Internet, or
            method of electronic storage, is 100% secure, however. Therefore, we
            cannot guarantee its absolute security. If you have any questions
            about security on our Web Pages, you can contact us by writing or
            email us.
          </p>
        </div>

        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>
            Correcting and Updating Your Personal Information
          </h2>
          <p className={`${styles.paragraph}`}>
            You may at any time and for any reason review or update your
            Personal Information, you may do so by login in to your account and
            edit.
          </p>
        </div>
        <div className="shadow-md px-8 py-10 h-min bg-slate-50 rounded-sm hover:scale-105">
          <h2 className={`${styles.heading} `}>
            Notification of Privacy Policy Changes
          </h2>
          <p className={`${styles.paragraph}`}>
            We may update this Privacy Policy to reflect changes to our privacy
            practices. If we make any material changes, we will notify you by
            email (sent to the email address specified in your account) or by
            means of a notice on our Web Pages or your account prior to the
            change becoming effective. We encourage you to periodically review
            this page for the latest information on our privacy practices.
          </p>
        </div>
      </section>
    </>
  );
};

export default Privacy;
